import { axiosPredsenseInstance } from "../App";
import { IMachine } from "../types/Machine";

import {
  localStorageGet,
  localStorageRemove,
  localStorageSet,
  removeTokens,
} from "../utils/LocalStorageHelper";

export const login = (email: string, password: string) => {
  return axiosPredsenseInstance
    .post(
      "/auth/login",
      { email, password },
      {
        headers: {
          noToast: true,
        },
      }
    )
    .then(({ data }) => {
      localStorageSet("loginUrl", window.location.pathname);
      localStorageSet("token", data.token);
      localStorageSet("refreshToken", data.refreshToken);

      return data.token;
    });
};

export const getNewTokens = (refreshToken: string) => {
  const formData = new FormData();
  formData.set("refreshToken", refreshToken);
  return axiosPredsenseInstance
    .post(
      `/auth/refresh-token`,
      { refreshToken },
      {
        headers: {
          noToast: true,
        },
      }
    )
    .then(({ data }) => {
      localStorageSet("token", data.token);
      localStorageSet("refreshToken", data.refreshToken);
    })
    .catch(() => {});
};

//signup with email and password and fullname
export const signup = (email: string, password: string, fullname: string) => {
  return axiosPredsenseInstance
    .post("/auth/signup", { email, password, fullname })
    .then((res) => res.data);
};

//get user profile
export const getUserProfile = () => {
  return axiosPredsenseInstance.get("/auth/user/info").then((res) => res.data);
};

//logout - remove token from local storage and redirect to login page
export const logout = () => {
  localStorageRemove("machine");
  removeTokens();
  localStorageRemove("loginUrl");
  window.location.href = "/";
};

export const logOutWithNextUrl = () => {
  removeTokens();
  const url = window.location.href;
  window.location.href =
    localStorageGet("loginUrl") || url.replace(window.location.origin, "");
};

//MACHINE
export const getMachines = () => {
  return axiosPredsenseInstance.get(`/api/machine/all`).then((res) => res.data);
};

export const getMachineByUuid = (machineUuid: string) => {
  return axiosPredsenseInstance
    .get(`/api/machine/${machineUuid}`, {
      headers: {
        noToast: true
      }
    })
    .then((res) => res.data)
    .catch((error) => {
      if (error.response?.status === 404) {
        localStorageRemove("machine");
        return Promise.reject({ response: { status: 404 } });
      }
      return Promise.reject(error);
    });
};

export const checkMachineExists = async (
  machineUuid: string
): Promise<boolean> => {
  try {
    await getMachineByUuid(machineUuid);
    return true;
  } catch (error) {
    return false;
  }
};

export const createMachine = (data: Partial<IMachine>) => {
  return axiosPredsenseInstance
    .post(`/api/machine/create`, data)
    .then((res) => res.data);
};

export const updateMachine = (data: Partial<IMachine>) => {
  return axiosPredsenseInstance
    .put(`/api/machine/${data.uuid}/update`, data)
    .then((res) => res.data);
};

export const deleteMachine = (machineUuid: string) =>
  axiosPredsenseInstance.delete(`/api/machine/${machineUuid}`);
